"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M677.647 283.848H1920V57.966H677.647v225.882zM0 57.966v1581.29h348.65v222.155l441.938-335.097-441.939-335.322v222.268H225.882V57.966H0zm677.647 677.76H1920V509.844H677.647v225.882zm0 451.652H1920V961.496H677.647v225.882zm1016.47 451.878H1920V1413.26h-225.882v225.996zm-338.823 0h225.995V1413.26h-225.995v225.996zm-338.823 0h225.882V1413.26H1016.47v225.996z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveDownBottom =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconMoveDownBottom, _Component);

  function IconMoveDownBottom() {
    (0, _classCallCheck2.default)(this, IconMoveDownBottom);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconMoveDownBottom).apply(this, arguments));
  }

  (0, _createClass2.default)(IconMoveDownBottom, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconMoveDownBottom",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconMoveDownBottom.displayName = "IconMoveDownBottom";
  return IconMoveDownBottom;
}(_react.Component);

exports.default = IconMoveDownBottom;
IconMoveDownBottom.glyphName = 'move-down-bottom';
IconMoveDownBottom.variant = 'Solid';
IconMoveDownBottom.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);